"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jpgSettings = exports.PAYMENT_METHODS = exports.PAYMENT_METHOD = void 0;
const PAYMENT_METHODS = exports.PAYMENT_METHODS = 'payment-methods';
const PAYMENT_METHOD = exports.PAYMENT_METHOD = 'payment-method';
const jpgSettings = exports.jpgSettings = ['h=70', 'q=90'];
